import { Typography } from 'designSystem';
import React from 'react';
import { pluralize } from 'utils/pluralize';
import { ListItemCard } from '../components/ListItemCard';
export var EvolusAdjustmentDetails = function (_a) {
    var _b, _c, _d;
    var details = _a.details;
    return (React.createElement(React.Fragment, null,
        React.createElement(ListItemCard, null,
            React.createElement(Typography, { variant: "headlineSmall", display: "inline" },
                details.redeemedForPoints,
                " adjustment",
                pluralize((_b = details.redeemedForPoints) !== null && _b !== void 0 ? _b : 0)),
            React.createElement(Typography, { variant: "headlineSmall", display: "inline", color: "link" },
                "-",
                details.redeemedForPoints,
                " Credit",
                pluralize((_c = details.redeemedForPoints) !== null && _c !== void 0 ? _c : 0))),
        React.createElement(ListItemCard, null,
            React.createElement(Typography, { variant: "headlineSmall", display: "inline" },
                "Adjusted By: ", (_d = details.facilityName) !== null && _d !== void 0 ? _d : 'Unknown'))));
};
